/**
 * @desc: 供应商 受理发行
 * @create：2020/4/21
 * @author: yeungxsheng
 * @version: v1.0
 */

import {
  getListData,
  fetchDetails,
  publish
} from '@/api/T2/acceptIssuance'

export default {
  namespaced: true,
  state: {
    list: ''
  },
  getters: {},
  mutations: {
    setList: (state, payload) => {
      state.list = payload
    },
    setDetails: (state, payload) => {
      state.setDetails = payload
    }
  },
  actions: {
    // 受理发行--列表接口
    getList({ commit }, payload) {
      return getListData(payload).then(res => {
        if (res && res.status === 200) {
          commit('setList', res.data)
          return res
        } else {
          return {}
        }
      })
    },

    // 受理发行 - 查看
    getDetails({ commit }, payload) {
      return fetchDetails(payload).then(res => {
        if (res && res.status === 200) {
          commit('setDetails', res.data)
          return res
        } else {
          return {}
        }
      })
    },

    // 发行 / 保存
    async submit(ctx, payload) {
      return await publish(payload)
    }
  }
}
